export default {
  productList: {
    total: "共 {total} 条",
    filter: "筛选条件",
    sortNum: "销量",
    sortPrice: "价格",
    sortEvaluate: "评价",
    sortNew: "新品",
    filterCategory: "分类",
    filterBrand: "品牌",
    filterTemperature: "运输方式",
    filterOrigin: "原产地",
    couponDetail: '优惠券详情',
    searchTitle: "{search}的搜索结果",
    proTitle: "商品列表",
    noProduct: "没有找到您想要的商品哦！",
    allClear: '全部清除'
  },
  productDetail: {
    productDetail: '商品详情',
    productStocknumTag: "在库紧张",
    proRateNum: "{num} 条评论",
    countdownNum: "限{num}份",
    countdownTime: "距活动结束还有",
    countStarTime: "距活动开始还有",
    proBrand: "品牌",
    proCode: "编号",
    proTemperature: "运输方式",
    proOrigin: "原产地",
    proPoints: "赠送积分",
    proCoupon: "优惠券",
    proCouponMore: "更多优惠券",
    proPromotion: "促销",
    proPromotionMore: "查看详情",
    delivery: "配送至",
    deliveryTime: "最快 {date} 送达",
    proNum: "数量",
    proNoNum: "对不起, 该商品暂无库存!",
    btnAddCart: "加入购物车",
    arrivalNotice: "到货通知",
    arrivalNoticeProp: "已添加到货通知",
    btnProOff: "商品已下架",
    proCollection: "收藏",
    proDescTitle: "商品描述",
    proDescParam: "规格详细",
    proReviews: "商品评价",
    proSaleTitle: "促销商品",
    proLatelyTitle: "最近浏览",
    proCouponTitle: "领取优惠券",
    proCouponBtnAdd: "立即领取",
    proCouponBtn: "已领取",
    proCouponBtnGo: "立即使用",
    disposals: "特卖品",
    relatedgoods: "相关商品",
    couponLable: '可领取',
    couponLable1: '已领取',
    couponType1: '满减券',
    couponType2: '满折券',
    couponType3: '包邮券',
    couponType1UseMoney_text1: '满{useMoneyCondition}减{discountInfo}',
    couponType1NoUseMoney: '任意金额减{discountInfo}',
    couponType2UseMoney: '滿{useMoneyCondition}享{discountInfo}%OFF',
    couponType2NoUseMoney: '任意金额享{discountInfo}%OFF',
    couponType3UseMoney: '滿{useMoneyCondition}包邮{discountInfo}',
    couponType3NoUseMoney: '任意金额包邮{discountInfo}',
    freeTransportName: '包邮{freetransportName}',
    couponProductType: '部分商品可用',
    couponProductType0: '全部商品可用',
    couponProductType1: '部分商品可用',
    couponProductType2: '部分商品不可用',
    freeTransportType: '{freeTransportAreaName}包邮',
    freeTransportTypeYw: '{freeTransportAreaName}以外包邮',
    receiveNum: '限领{num}张',
    useDate: '有效期',
    dateInterval: '至',
    dateSameDay: '领券当日开始 {day} 天有效',
    dateNextDay: '领券次日开始 {day} 天有效',
    receive: '领取',
    toUse: '去使用',
    CouponSuccess: '领取成功',
    CollectSuccess: '收藏成功',
    CollectDeleteSuccess: '取消成功',
    noComments: '暂无评价',
    activitTextStart: '距活动开始还有',
    activitTextEnd: '距活动结束还有',
    day: '天',
    hour: '小时',
    minute: '分钟',
    second: '秒',
    all: '全部',
    picture: '有图',
    praise: '好评',
    middle_feedback: '中评',
    negative_feedback: '差评',
    current: '只看选中规格的评价',
    noEvaluate: '暂无评论',
    nodesc: '暂无描述哦~~',
    fastReceiveDateTootip: '系统会根据您的配送地址预估最快送达日。您还可以在结账页面免费指定收货时间。*如遇天候，交通状况等不可抗力因素，配达可能会延迟，还望理解。'
  }
};